/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const ITINERARY_FACILITIES = [
    '251865', // APOS
    '253730', // CUMB
    '251854', // CANA
    '234783', // HALA
    '252494', // WHIT
    '256367', // PICR
    '250860', // OKEF
    '249981', // VOYA
    '10028678', // SUAG
    '10048983', // Mammoth Cave Backcountry Camping
    '10028875', // Big Bend Backcountry Camping
    '10119505', // Hōlua Tent Campground (Wilderness Tent Permits)
    '10119569', // Palikū Tent Campground (Wilderness Tent Permits)
    '10145539', // Katahdin Woods And Waters National Monument Camping And Huts
];

export const ITINERARY_DEFAULT = [
    '252494', // White Mountains National Recreation Area - Alaska Cabins
    '249981', // Voyageurs National Park Camping Permits
];

export const ITINERARY_GROUPED = [
    '234783', // Haleakala National Park (Cabin Permits)
    '251854', // Canaveral National Seashore Permits
    '256367', // Pictured Rocks National Lakeshore Backcountry Camping Permit
];

export const ITINERARY_SINGLE = [
    '251865', // Apostle Islands National Lakeshore Camping Permits
];

export const ITINERARIES_WITH_RENTALS = [
    '249981', // Voyageurs National Park Camping Permits
];

export const entrances = [
    [-82.140006, 30.738701, 'Suwanee Canal Recreation Area', 'SCRA'],
    [-82.361379, 30.826827, 'Stephen C. Foster State Park ', 'SFSP'],
    [-82.137564, 30.954703, 'Kingfisher Landing', 'KF'],
];

export const geometryDeadEnds = [
    [-82.286991, 30.899673, 0],
    [-82.302721, 30.875423, 0],
    [-82.360364, 30.83188, 0],
    [-82.360723, 30.829398, 0],
    [-82.247416, 30.803762, 0],
    [-82.253198, 30.845458, 0],
    [-82.164144, 30.873817, 0],
    [-82.164164, 30.873813, 0],
    [-82.161998, 30.874908, 0],
    [-82.161491, 30.875163, 0],
    [-82.161219, 30.875211, 0],
    [-82.343566, 30.834712, 0],
    [-82.253303, 30.846437, 0],
    [-82.137315, 30.955125, 0],
    [-82.253711, 30.84641, 0],
    [-82.17331, 30.737302, 0],
    [-82.163296, 30.735465, 0],
];
